(function () {
  function initItem(details) {
    if (details.__faqInit) return;
    details.__faqInit = true;
    var summary = details.querySelector('summary');
    var answer = details.querySelector('.brand-faq__answer');
    if (!summary || !answer) return;
    var busy = false;

    function onEnd(after) {
      var handler = function (e) {
        if (e.target !== answer || e.propertyName !== 'height') return;
        answer.removeEventListener('transitionend', handler);
        after();
      };
      answer.addEventListener('transitionend', handler);
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      busy = true;
      details.classList.add('brand-faq__item--animating');

      if (details.open) {
        answer.style.height = answer.scrollHeight + 'px';
        void answer.offsetHeight;
        answer.style.height = '0px';
        onEnd(function () {
          details.open = false;
          details.classList.remove('brand-faq__item--animating');
          answer.style.height = '';
          busy = false;
        });
      } else {
        details.open = true;
        var target = answer.scrollHeight;
        answer.style.height = '0px';
        void answer.offsetHeight;
        answer.style.height = target + 'px';
        onEnd(function () {
          details.classList.remove('brand-faq__item--animating');
          answer.style.height = '';
          busy = false;
        });
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.brand-faq__item').forEach(initItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
